import React from 'react';
import { StyledSubwayAddAdGroupButton } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons';
import { SubwayAddAdGroupProps } from './types';

export const SubwayAddAdGroup = ({
  disabled,
  ...props
}: SubwayAddAdGroupProps) => {
  return (
    <StyledSubwayAddAdGroupButton
      {...props}
      data-testid="subway-add-adgroup-button"
      disabled={disabled}
      disableRipple
      startIcon={
        <FontAwesomeIcon width={12} height={12} icon={faPlusCircle} />
      }
    >
      Ad Group
    </StyledSubwayAddAdGroupButton>
  );
};
